<template>
  <b-sidebar
    id="add-new-uom-sidebar"
    :visible="isAddNewUOMSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-u-o-m-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add New Unit of Measure</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <div class="p-2">
        <u-o-m-form
          :form-data.sync="formData"
          :loading="isSubmitting"
          @submit="onSubmit"
          @cancel="hide"
        />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import store from '@/store';
import UOMForm from './UOMForm.vue';

export default {
  name: 'UOMListAddNew',
  components: {
    BSidebar,
    UOMForm,
  },
  props: {
    isAddNewUOMSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isSubmitting = ref(false);
    const formData = ref(null);

    const resetForm = () => {
      formData.value = null;
    };

    const onSubmit = async () => {
      console.log('=== UOM Add On Submit', JSON.stringify(formData.value, null, 2));

      isSubmitting.value = true;

      try {
        formData.value.businessID = store.state.user.businessID;

        await store.dispatch('fbr-invoice-unit-of-measure/addUOM', formData.value);

        // Show success toast
        store.dispatch('app/showToast', {
          title: 'Success',
          text: 'Unit of Measure added successfully',
          variant: 'success',
        });

        // Reset form data to clear all fields
        formData.value = {
          id: 0,
          name: '',
          abbreviation: '',
          description: '',
          isActive: true,
          businessID: store.state.user.businessID,
        };

        // Close sidebar and refetch data
        emit('update:is-add-new-u-o-m-sidebar-active', false);
        emit('refetch-data');
      } catch (error) {
        console.error('Error adding UOM:', error);

        // Show user-friendly error message
        let errorMessage = 'Error adding Unit of Measure. Please try again.';

        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        // Show error toast
        store.dispatch('app/showToast', {
          title: 'Error',
          text: errorMessage,
          variant: 'danger',
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      isSubmitting,
      formData,
      onSubmit,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
#add-new-uom-sidebar {
  .content-sidebar-header {
    padding: 1rem 1.5rem !important;
  }
}
</style>
